import React from "react";
import Blog_50_4 from "../component/Blog_50_4";
function Blog_50_4_container() {
  return <Blog_50_4 />;
}

export default Blog_50_4_container;
